import React from 'react'
import { useTranslation } from 'react-i18next'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import Chip from '@material-ui/core/Chip'
import CircularProgress from '@material-ui/core/CircularProgress'

export const COMPARISON_COLORS = [
  '#1f77b4', '#e377c2', '#2ca02c', '#d62728', '#9467bd',
  '#8c564b', '#ff7f0e', '#7f7f7f', '#bcbd22', '#17becf',
]

export const MultiLayerSelector = ({
  layers,
  selectedLayers,
  onChange,
  loading,
}) => {
  const { t, i18n } = useTranslation()

  const getLayerLabel = (layer) =>
    i18n.exists(`Layer.${layer.name}`) ? t(`Layer.${layer.name}`) : layer.displayed_name

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={(layers || []).filter((l) => l.is_sentinel || l.name.endsWith('WMS'))}
      value={selectedLayers}
      onChange={(event, newValue) => onChange(newValue)}
      getOptionLabel={getLayerLabel}
      getOptionSelected={(option, value) => option.key === value.key}
      renderTags={(value, getTagProps) =>
        value.map((layer, index) => (
          <Chip
            key={layer.key}
            label={getLayerLabel(layer)}
            size="small"
            style={{
              backgroundColor: COMPARISON_COLORS[index % COMPARISON_COLORS.length],
              color: '#fff',
              fontWeight: 500,
            }}
            {...getTagProps({ index })}
          />
        ))
      }
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('Layers')}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={18} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      style={{ width: '100%', maxWidth: 300 }}
    />
  )
}
